import { UserRole, UserStatus } from '@/resource/user/user.model';
import jsCookie from 'js-cookie';

export enum COOKIE {
  TOKEN = 'token',
  SIGNOUT = 'signout',
  ROLE = 'role',
  EMAIL = 'email',
  STATUS = 'status',
  IS_SUSPENDED = 'is_suspended',
  SOURCE = 'source',
  SEEN_TUTORIAL = 'seen_tutorial',
  HAS_REVIEWED = 'has_reviewed_1',
  PDF_DOWNLOADED = 'pdf_downloaded_2',
  AFFILIATE_CODE = 'affiliate_code',
  CLOSE_STUDY_GROUP = 'life-time-deal',
}

let DEFAULT_ROLE: UserRole | null = null;
let DEFAULT_CLOSE_STUDY_GROUP: boolean | null = null;

export function updateDefaultRole(role: string) {
  DEFAULT_ROLE = role as UserRole;
}

export function updateDefaultStudyGroup(studyGroup: boolean) {
  DEFAULT_CLOSE_STUDY_GROUP = studyGroup;
}

export const COOKIE_EXPIRATION = 14; // In days

const cookie = jsCookie;
export default cookie;

export function getToken(): string | null {
  const token = cookie.get(COOKIE.TOKEN);

  if (!token) {
    return null;
  }

  return token;
}

export function getSignout(): string | null {
  const signout = cookie.get(COOKIE.SIGNOUT);

  if (!signout) {
    return null;
  }

  return signout;
}

export function getRole(): UserRole | null {
  if (DEFAULT_ROLE) {
    return DEFAULT_ROLE;
  }

  const role = cookie.get(COOKIE.ROLE);

  if (!role) {
    return null;
  }

  return role as UserRole;
}

export function getEmail(): string | null {
  const token = cookie.get(COOKIE.EMAIL);

  if (!token) {
    return null;
  }

  return token;
}

export function getUserStatus(): UserStatus | null {
  const status = cookie.get(COOKIE.STATUS);

  if (!status) {
    return null;
  }

  return status as UserStatus;
}

export function getSource(): string | null {
  const source = cookie.get(COOKIE.SOURCE);

  if (!source) {
    return null;
  }

  return source;
}

export function getUserIsSuspended(): boolean {
  const isSuspended = cookie.get(COOKIE.IS_SUSPENDED);

  if (!isSuspended) {
    return false;
  }

  if (isSuspended === 'true') {
    return true;
  } else {
    return false;
  }
}

export function getSeenTutorial(): boolean {
  const seenTutorial = cookie.get(COOKIE.SEEN_TUTORIAL);

  if (!seenTutorial) {
    return false;
  }

  if (seenTutorial === 'true') {
    return true;
  } else {
    return false;
  }
}

export function getCloseStudyGroup(): boolean {
  if (DEFAULT_CLOSE_STUDY_GROUP) {
    return DEFAULT_CLOSE_STUDY_GROUP;
  }

  const closeStudyGroup = cookie.get(COOKIE.CLOSE_STUDY_GROUP);

  if (!closeStudyGroup) {
    return false;
  }

  if (closeStudyGroup === 'true') {
    return true;
  } else {
    return false;
  }
}

export function setCookieSeenTutorialToTrue() {
  cookie.set(COOKIE.SEEN_TUTORIAL, 'true', {
    sameSite: 'strict',
    expires: COOKIE_EXPIRATION,
  });
}

export function getUserReviewed(): boolean {
  const hasReviewed = cookie.get(COOKIE.HAS_REVIEWED);

  if (!hasReviewed) {
    return false;
  }

  if (hasReviewed === 'true') {
    return true;
  } else {
    return false;
  }
}

export function getPdfDownloaded(): number {
  const pdfDownloaded = cookie.get(COOKIE.PDF_DOWNLOADED);

  if (!pdfDownloaded) {
    return 0;
  }

  return Number(pdfDownloaded);
}

export function getAffiliateCode(): string | null {
  const affiliateCode = cookie.get(COOKIE.AFFILIATE_CODE);

  if (!affiliateCode) {
    return null;
  }

  return affiliateCode as string;
}
